import React from "react";
import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";
import postalven from "../assets/postalven.com_.png";
import antenne5g from "../assets/antenne5g.it_.png";
import adley from "../assets/adley.ai_.png";
import venulink from "../assets/venulink.png";

const Work = () => {
  const { ref, inView } = useInView({ threshold: 0.1 });

  return (
    <motion.div
      ref={ref}
      initial={{ opacity: 0 }}
      animate={inView && { opacity: 1 }}
      transition={{
        type: "keyframes",
        duration: window.matchMedia("(max-width: 850px)").matches ? 0.5 : 1.5,
        bounce: 1,
        delay: window.matchMedia("(max-width: 850px)").matches ? 0 : 0.5,
      }}
      className="Work mt-5"
    >
      <div>
        <div className="text-white">
          <div className="h-relative mx-auto">
            <h1 className="fw-bold Section-heading">WORK</h1>
          </div>
          <div className="mt-5 d-flex  flex-row align-items-center row-resp">
            <img src={adley} alt="Project 1 - Adley.com" className="work_img" />
            <div className="ms-3">
              <h3>
                <a href="https://adley.ai" className="highlight"
                  style={{borderBottom: "1.99px solid white"}}
                  target="_blank">
                  Adley.ai
                </a>
              </h3>
              <p className="text-white mt-2">
                Adley.ai stands as an innovative solution in the realm of
                artificial intelligence and marketing. Through cutting-edge
                technology and intelligent algorithms, the website provides
                businesses with powerful tools to enhance their marketing
                strategies and optimize their digital presence, paving the way for
                efficient and data-driven decision-making.
              </p>
            </div>
          </div>
          <div className="mt-5 d-flex flex-row-reverse align-items-center row-resp">
            <img
              src={venulink}
              alt="Project 1 - mycellphone.shop"
              className="work_img"
            />
            <div className="me-3">
              <h3>
                <a
                  href="https://venulink.org/"
                  className="highlight"
                  style={{borderBottom: "1.99px solid white"}}
                  target="_blank"
                >
                  VenuLink
                </a>
              </h3>
              <p className="text-white mt-2">
                Venulink is a revolutionary platform designed to simplify the process of finding and booking live music gigs. I develop this website using the fundamentals HTML, CSS and JavaScript with Firebase as database.
              </p>
            </div>
          </div>
          <div className="mt-5 d-flex flex-row align-items-center row-resp">
            <img
              src={postalven}
              alt="Project 1 - Postalven.com"
              className="work_img"
            />
            <div className="ms-3">
              <h3>
                <a
                  href="https://postalven.com"
                  className="highlight"
                  target="_blank"
                  style={{borderBottom: "1.99px solid white"}}
                >
                  Postalven.com
                </a>
              </h3>
              <p className="text-white mt-2">
                Postalven.com is a comprehensive platform designed to streamline
                and optimize the shipping process for businesses. Through
                intuitive design and robust functionality, the website offers a
                seamless experience for managing logistics and deliveries,
                contributing to enhanced operational efficiency.
              </p>
            </div>
          </div>
        </div>
        <div className="d-flex flex-row-reverse align-items-center mt-5 row-resp">
          <img
            src={antenne5g}
            alt="Project 2 - Antenne5g.it"
            className="work_img"
          />
          <div className="me-3">
            <h3>
              <a
                href="https://antenne5g.it"
                className="highlight-2"
                target="_blank"
                style={{borderBottom: "1.99px solid white"}}
              >
                Antenne5g.it
              </a>
            </h3>
            <p className="text-white mt-2">
              Antenne5g.it serves as an informative hub focusing on 5G
              technology and its implications. With a user-friendly interface
              and valuable insights, the website acts as a reliable resource for
              individuals and businesses seeking to understand the latest
              advancements and developments in the realm of 5G technology.
            </p>
          </div>
        </div>

      </div>
    </motion.div>
  );
};

export default Work;
